import api from "./api";

/**
 * Integração Excel com IA (ERP = 6).
 *
 * O Frontend nunca fala com o integrador: todas as rotas abaixo são do Backend, que valida JWT,
 * tenant e permissão antes de repassar. O `integrationId` nunca trafega daqui — é lido do Sync no
 * servidor.
 */
class ExcelAiService {
  // ------------------------------------------------------------------ arquivos ----------

  static async listarArquivos(syncId) {
    const { data } = await api.get(`/sync/excel-ai/${syncId}/files`);
    return data?.response || [];
  }

  /**
   * Anexa um lote. Devolve `{ aceitos, rejeitados }` — um arquivo recusado não derruba os outros,
   * e a tela mostra o motivo de cada recusa.
   */
  static async anexarArquivos(syncId, arquivos, onProgress) {
    const form = new FormData();
    arquivos.forEach((arquivo) => form.append("files", arquivo));

    const { data } = await api.post(`/sync/excel-ai/${syncId}/files`, form, {
      headers: { "Content-Type": "multipart/form-data" },
      onUploadProgress: (evento) => {
        if (!onProgress || !evento.total) return;
        onProgress(Math.round((evento.loaded * 100) / evento.total));
      },
    });

    return data?.response || { aceitos: [], rejeitados: [] };
  }

  static async removerArquivo(fileId) {
    const { data } = await api.delete(`/sync/excel-ai/files/${fileId}`);
    return data?.response;
  }

  static async baixarArquivo(fileId) {
    const { data } = await api.get(`/sync/excel-ai/files/${fileId}/download`);
    return data;
  }

  // -------------------------------------------------------------- processamento --------

  static async processar(syncId) {
    const { data } = await api.post(`/sync/excel-ai/${syncId}/process`);
    return data?.response;
  }

  static async listarRuns(syncId, take = 10) {
    const { data } = await api.get(`/sync/excel-ai/${syncId}/runs`, { params: { take } });
    // Rota de proxy: o corpo vem do integrador como está, sem o envelope `response` do Backend.
    return Array.isArray(data) ? data : data?.runs || [];
  }

  static async obterRun(syncId, runId) {
    const { data } = await api.get(`/sync/excel-ai/${syncId}/runs/${runId}`);
    return data;
  }

  static async listarPendencias(syncId, runId) {
    const { data } = await api.get(`/sync/excel-ai/${syncId}/runs/${runId}/pendencias`);
    return Array.isArray(data) ? data : data?.pendencias || [];
  }

  static async resolverPendencias(syncId, runId, resolucoes) {
    const { data } = await api.post(
      `/sync/excel-ai/${syncId}/runs/${runId}/pendencias/resolver`,
      { resolucoes },
    );
    return data;
  }
}

export default ExcelAiService;
